import React from 'react';

interface InlineImageStatusProps {
    uploading: boolean;
    error: string | null;
    onDismiss: () => void;
}

const InlineImageStatus: React.FC<InlineImageStatusProps> = ({ uploading, error, onDismiss }) => {
    if (!uploading && !error) return null;
    return (
        <div className="flex items-center gap-2 pt-1 text-[11px]">
            {uploading && (
                <span className="inline-flex items-center gap-1.5 text-gray-500" role="status">
                    <span className="h-2.5 w-2.5 rounded-full border-2 border-gray-400 border-t-transparent animate-spin" />
                    Uploading image&hellip;
                </span>
            )}
            {error && (
                <>
                    <span className="text-red-500" role="alert">
                        {error}
                    </span>
                    <button
                        type="button"
                        onClick={onDismiss}
                        className="ml-auto text-gray-400 hover:text-gray-600"
                    >
                        Dismiss
                    </button>
                </>
            )}
        </div>
    );
};

export { InlineImageStatus };
